module.exports = __webpack_public_path__ + "static/media/Modulation (Lush Ensemble) VR.87ee563.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/pedal/Modulation (Lush Ensemble) VR.mp3
// module id = 7v0D
// module chunks = 12